// extracted by mini-css-extract-plugin
export var contentBody = "_bs-9";
export var headerImage = "_bs-2";
export var imageButton = "_bs-7";
export var imageButtonIcon = "_bs-8";
export var imageHeader = "_bs-4";
export var imageHeaderText = "_bs-5";
export var imageOverlay = "_bs-3";
export var imageTitle = "_bs-6";
export var imageWrapper = "_bs-1";
export var taskList = "_bs-a";
export var widget = "_bs-0";